import { useSessionWithUser } from "src/components/session/session";
import { useIsFeatureEnabled } from "src/hooks/useIsFeatureEnabled";
import { useListUserMembershipsQuery } from "src/gql/codegen/graphql";
import { ShowStatus } from "../types";
import { JoinedForWorkRenderProps } from "./JoinedForWorkBanner";
import {
  tryLocalStorageGetItem,
  tryLocalStorageSetItem,
} from "src/utils/storage/storage";
import { useState } from "react";

export const useShouldShowJoinedForWorkButNoTeamBanner = (): [
  ShowStatus,
  JoinedForWorkRenderProps | null,
] => {
  const session = useSessionWithUser();
  const isFlagEnabled = useIsFeatureEnabled(
    "prompt-joined-for-work-but-not-team-banner"
  );
  const bannerId = "joined_for_work_but_no_team_banner";
  const [isDismissed, setDismissed] = useState(
    tryLocalStorageGetItem(bannerId) === "dismissed"
  );
  const result = useListUserMembershipsQuery({
    skip: session?.user?.id === undefined || isDismissed,
    context: { session },
    variables: {
      user_id: session?.user?.id,
      user_email: session?.email,
    },
  });

  if (result.loading || result.error !== undefined) {
    return ["loading", null];
  }

  if (session === undefined || !isFlagEnabled || isDismissed) {
    return ["dont-show", null];
  }

  const userHasNoTeams = () => {
    return (
      result.data !== null &&
      result.data !== undefined &&
      result.data.memberships_private_details.length === 0
    );
  };
  const userSignedUpMoreThan7DaysAgo = () => {
    const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000;
    return (
      Date.now() - new Date(session.user.created_at).valueOf() > sevenDaysInMs
    );
  };
  const userJoinedForJob = () => {
    return session.user.onboarding_questions?.brings_to_dune === "job";
  };

  if (
    userJoinedForJob() &&
    userHasNoTeams() &&
    userSignedUpMoreThan7DaysAgo()
  ) {
    return [
      "show",
      {
        userId: session.user.id,
        onDismiss: () => {
          tryLocalStorageSetItem(bannerId, "dismissed");
          setDismissed(true);
        },
      },
    ];
  }
  return ["dont-show", null];
};
